var maxLength = function (length) {
    return function (value) { return ("" + value).length <= length; };
};

export { maxLength };
